import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


type SetPasswordOutput = {
  status: string;
  error?: string;
};


export type SetPasswordParams = {
  password: string;
  token: string;
  isInviteToken: boolean;
};


export const setPassword = (params: SetPasswordParams) => {
  return restClient.request<SetPasswordOutput>(
    '/auth/set_password',
    {
      method: 'POST',
      data: snakecaseKeys(params),
    }
  );
};
